import axios from "axios";

import { API_URL_ORGANIZATION_FUNCTIONS } from "../constants";

export default class OrganizationFunctionsService {
    static instance;

    static getInstance() {
        if (!OrganizationFunctionsService.instance) {
            OrganizationFunctionsService.instance =
                new OrganizationFunctionsService();
        }

        return OrganizationFunctionsService.instance;
    }

    getHeaders() {
        return {
            Authorization: `Bearer ${localStorage.getItem(
                "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
            )}`,
        };
    }

    async list() {
        const response = await axios.get(API_URL_ORGANIZATION_FUNCTIONS, {
            headers: this.getHeaders(),
        });

        return response.data;
    }

    async show(key) {
        const response = await axios.get(
            `${API_URL_ORGANIZATION_FUNCTIONS}/${key}`,
            {
                headers: this.getHeaders(),
            }
        );

        return response.data;
    }

    async create(payload) {
        const response = await axios.post(
            API_URL_ORGANIZATION_FUNCTIONS,
            payload,
            {
                headers: this.getHeaders(),
            }
        );

        return response.data;
    }

    async update(key, payload) {
        try {
            const response = await axios.patch(
                `${API_URL_ORGANIZATION_FUNCTIONS}/${key}`,
                payload,
                {
                    headers: this.getHeaders(),
                }
            );

            return response.data;
        } catch (error) {
            if (error?.response?.status !== 405) {
                throw error;
            }

            const response = await axios.post(
                `${API_URL_ORGANIZATION_FUNCTIONS}/${key}`,
                payload,
                {
                    headers: this.getHeaders(),
                }
            );

            return response.data;
        }
    }

    async remove(key) {
        const response = await axios.delete(
            `${API_URL_ORGANIZATION_FUNCTIONS}/${key}`,
            {
                headers: this.getHeaders(),
            }
        );

        return response.data;
    }

    async assign(key, userId) {
        const response = await axios.post(
            `${API_URL_ORGANIZATION_FUNCTIONS}/${key}/assign`,
            { user_id: userId },
            {
                headers: this.getHeaders(),
            }
        );

        return response.data;
    }

    async replaceDpo(userId) {
        const response = await axios.post(
            `${API_URL_ORGANIZATION_FUNCTIONS}/dpo/replace`,
            { user_id: userId },
            {
                headers: this.getHeaders(),
            }
        );

        return response.data;
    }

    async unassign(key, userId) {
        const response = await axios.delete(
            `${API_URL_ORGANIZATION_FUNCTIONS}/${key}/assignments/${userId}`,
            {
                headers: this.getHeaders(),
            }
        );

        return response.data;
    }
}
